import { MapPin } from "lucide-react";
import { LINKS } from "../data/content";
import { Reveal } from "./Reveal";

const Footer = () => (
  <footer data-testid="press-kit-footer" className="bg-[#F8FAF8] border-t border-[#0D3B3E]/10 pt-16 pb-10 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="text-outline font-display font-bold text-[11.5vw] lg:text-[9vw] leading-none tracking-tight whitespace-nowrap select-none text-center">
          DR. MUGDHA ADHIKARI
        </p>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-3 gap-8 border-t border-[#0D3B3E]/10 pt-10">
        <div>
          <p className="text-[10px] font-mono tracking-[0.22em] text-[#0D9488] mb-4">CLINIC</p>
          <p className="text-sm text-slate-600 leading-relaxed flex gap-2">
            <MapPin className="w-4 h-4 text-[#0D9488] shrink-0 mt-0.5" />
            Gentle Cure Homoeoclinic,
            <br />
            Kandivali West, Mumbai — 400067
          </p>
        </div>
        <div>
          <p className="text-[10px] font-mono tracking-[0.22em] text-[#0D9488] mb-4">CONTACT</p>
          <a
            data-testid="footer-phone-link"
            href={LINKS.phone}
            className="block text-sm text-slate-600 hover:text-[#0D9488] transition-colors duration-300"
          >
            +91 88501 59361
          </a>
          <a
            data-testid="footer-email-link"
            href={LINKS.email}
            className="block text-sm text-slate-600 hover:text-[#0D9488] transition-colors duration-300 mt-2 break-all"
          >
            mugdhaadhikari9594@gmail.com
          </a>
        </div>
        <div>
          <p className="text-[10px] font-mono tracking-[0.22em] text-[#0D9488] mb-4">CONSULTATIONS</p>
          <p className="text-sm text-slate-600 leading-relaxed">
            In-clinic · Kandivali West
            <br />
            Online · Worldwide via WhatsApp
          </p>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-[#0D3B3E]/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-[10px] font-mono tracking-[0.2em] text-slate-500">
          © 2026 DR. MUGDHA ADHIKARI — GENTLE CURE HOMOEOCLINIC
        </p>
        <p className="text-[10px] font-mono tracking-[0.2em] text-slate-400">PRESS KIT // 2026 · MUMBAI, IN</p>
      </div>
    </div>
  </footer>
);

export default Footer;
